import { AreaEntityNode, EntityAccesses } from "../models/roles";
import { PermissionsInfo } from "../components/permissions-info";

export function permissionAreaKeyNameOf(name: Extract<keyof EntityAccesses, string>): string {
    return name;
};

export function permissionEnityKeyNameOf<T extends AreaEntityNode>(name: Extract<keyof T, string>): string {
    return name;
};

export function getPermissionInfo<T extends EntityAccesses, K1 extends keyof T, K2 extends keyof T[K1]>(a: K1, b: K2) : PermissionsInfo {
    return { areaPermissionKey: a as string, entityPermissionKey: b as string };
};